export const ADMIN_ROLE = "admin" as const;
export const STANDARD_ROLE = "standard" as const;

export type AppRole = typeof ADMIN_ROLE | typeof STANDARD_ROLE;

export const ALLOWED_ADMIN_ROLES: AppRole[] = [ADMIN_ROLE];

export function normalizeRole(role: unknown): AppRole {
  if (role === ADMIN_ROLE) {
    return ADMIN_ROLE;
  }
  return STANDARD_ROLE;
}
